import React, {Fragment, useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import {useTranslation} from 'react-i18next';
import {Divider, Grid} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import AgyleButton from '../components/ui/buttons/agyleButton';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useSelector} from 'react-redux';
import {ctxSplitScreen} from '../store/reducers/patientContext';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    backDrop: {
        // backdropFilter: theme.palette.blur,
    },
    centerButton: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    absolute: {
        position: 'absolute',
    },
}));

function MessageBox(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const theme = useTheme();
    const [disabledAccept, setDisabledAccept] = useState(false);
    const isAgyle = process.env.BUILD_MODULE === 'agyle';

    const splitScreen = useSelector(ctxSplitScreen);
    const disablePortal = props?.disablePortal ?? splitScreen?.enabled;

    const handleClose = (event, type) => {
        props.onClose(event, type);
    };

    const handleAccept = () => {
        setDisabledAccept(props.disableOnAccept);
        props.onAccept();
    };

    const handlePressEnter = (e) => {
        if (props.submitOnEnter && e?.code === 'Enter' && !props.disableSave && !props.disabled) {
            handleAccept();
        }
    };

    useEffect(() => {
        if (props.open)
            setDisabledAccept(false);
    }, [props.open]);

    return (
        <Dialog
            onClose={props.disableBackgroundClick ? null : handleClose}
            open={props.open}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    backgroundImage: props.bookAdmission ? 'none' : '',
                    backgroundColor: props.bookAdmission ? theme.palette.bookAdmissions.modalBackgroundColor
                        : (isAgyle ? theme.palette.inPatient.formBackground : theme.palette.background.dialog),
                },
            }}
            BackdropProps={{
                classes: {
                    root: clsx(disablePortal && classes.absolute, classes.backDrop)
                },
            }}
            style={{position: disablePortal ? 'absolute' : ''}}
            fullWidth={props.fullWidth}
            maxWidth={props.width}
            onKeyDown={handlePressEnter}
            disablePortal={disablePortal}
        >
            <DialogTitle>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <div>
                        {props.title}
                    </div>

                    {!props.disableCloseCross &&
                        <div>
                            <IconButton
                                disableRipple
                                onClick={handleClose}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </div>
                    }
                </Grid>
            </DialogTitle>

            <Divider/>

            <DialogContent style={{minWidth: props.minWidth}} className={'scroll-normal-white'}>
                {props.messageObject &&
                    props.messageObject
                }

                {!props.messageObject &&
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.message,
                        }}
                    />
                }
            </DialogContent>

            <DialogActions style={{display: 'flex', justifyContent: 'space-between'}}>
                {!props.haveAccept &&
                    <AgyleButton
                        onClick={handleClose}
                        colour="primary"
                    >
                        {t('Ok')}
                    </AgyleButton>
                }
                {props.haveAccept &&
                    <Fragment>
                        {props.haveAccept?.no &&
                            <AgyleButton
                                onClick={handleClose}
                                colour="primary"
                            >
                                {props.haveAccept.no}
                            </AgyleButton>
                        }

                        {props.haveAccept?.yes &&
                            <AgyleButton
                                onClick={handleAccept}
                                disabled={props.disableSave ? props.disabled : disabledAccept}
                                variant="contained"
                                colour={props.warning ? 'error' : ''}
                            >
                                {props.haveAccept.yes}
                            </AgyleButton>
                        }
                    </Fragment>
                }
            </DialogActions>
        </Dialog>
    );
}

export default MessageBox;

MessageBox.propTypes = {
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
    open: PropTypes.bool,
    disableSave: PropTypes.bool,
    disabled: PropTypes.bool,
    disableBackgroundClick: PropTypes.bool,
    disableCloseCross: PropTypes.bool,
    title: PropTypes.string,
    message: PropTypes.string,
    messageObject: PropTypes.any,
    haveAccept: PropTypes.object,
    warning: PropTypes.bool,
    minWidth: PropTypes.number,
    width: PropTypes.oneOf(['xl', 'md', 'sm', 'xs', 'lg', false]),
    fullWidth: PropTypes.bool,
    submitOnEnter: PropTypes.bool,
    disableOnAccept: PropTypes.bool,
    disablePortal: PropTypes.bool,
};

MessageBox.defaultProps = {
    disableBackgroundClick: false,
    disableCloseCross: false,
    disableSave: false,
    disabled: false,
    warning: false,
    messageObject: null,
    title: 'Message',
    message: '',
    minWidth: 0,
    width: 'sm',
    fullWidth: false,
    submitOnEnter: false,
    disableOnAccept: false,
    disablePortal: undefined,
};
